import { QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import SplashPage from '@/components/SplashPage';
// import { ThemeSampler } from '@/components/ThemeSampler';
import { trpc, createTRPCClient, createQueryClient } from '@/lib/trpc';
import { StoreProvider } from '@/stores';

/**
 * Root application component.
 *
 * Sets up all providers:
 * - tRPC + React Query for API communication
 * - MobX stores for state management
 * - Error boundary for graceful error handling
 */
export function App(): React.ReactElement {
  // Create clients once and store in state to prevent recreation on re-renders
  const [queryClient] = useState(() => createQueryClient());
  const [trpcClient] = useState(() => createTRPCClient());

  return (
    <ErrorBoundary>
      <trpc.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <StoreProvider>
            {/* <ThemeSampler /> */}
            <SplashPage />
          </StoreProvider>
        </QueryClientProvider>
      </trpc.Provider>
    </ErrorBoundary>
  );
}
